import { FEED_MENUMANIFESTAZIONI, feedMenuManifestazioniActionType, MenuManifestazioni } from './types';

export const feedMenuManifestazioni = (payload: MenuManifestazioni): feedMenuManifestazioniActionType => ({
  type: FEED_MENUMANIFESTAZIONI,
  payload,
});
